import { Component, OnInit } from '@angular/core';
import { Act } from '../../logic/act';
import { Actions } from '../../logic/enum/actions';
import { AppViewStates } from '../../logic/enum/app-view-states';
import { Model } from '../../logic/model';

@Component({
    selector: 'app-main-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.less'],
    standalone: false
})
export class MainMenuComponent implements OnInit {

  public AppViewStates = AppViewStates;
  public Actions = Actions;

  constructor(public model: Model, public act: Act) { }

  ngOnInit(): void {

  }

  btnHelpClick(){
    this.model.helpVisible.update(value => !value);
    this.act.do(this.Actions.settingsLocalSave);
  }

}
